import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-question-block',
  templateUrl: './disable-question-block.component.html',
  styleUrls: ['./disable-question-block.component.css'],
})
export class DisableQuestionBlockComponent {
  @Input() question!: Question;
}
